import { LessonDefinition } from "../../types";

const lesson: LessonDefinition = {
  id: "call-signs",
  courseId: "your-style",
  order: 3,
  title: "Call signs",
  summary:
    "Your unit designator goes into the narrative in your department's format, and you can override it for a single report when your shift changes.",
  learn: [
    "Turn on the call sign and pick its format and placement",
    "Override the call sign for one report at upload",
    "Understand how badge number interacts with the format",
  ],
  sceneId: "call-signs",
  tourId: "call-signs",
  minutes: 3,
  releasedAt: "2025-06-01T00:00:00.000Z",
  body: [
    {
      type: "paragraph",
      text: "If your reports refer to you by a unit designator such as \"1-1\", set a call sign once in Report Preferences and the AI writes it in the format you choose.",
    },
    {
      type: "steps",
      items: [
        "Open **Report Preferences** and turn on the call sign toggle. The Call Sign field, Format, and Placement appear.",
        "Type your call sign (for example 1-1).",
        "Choose a Format.",
        "Choose a Placement: first mention only, or every mention.",
        "Click **Save Preferences**.",
      ],
    },
    {
      type: "paragraph",
      text: "The Format options are built from your real rank, name, and badge, so you see exactly how each will read: \"1-1 (Officer Smith)\", \"Officer Smith - 1-1\", or \"Officer Smith (1-1)\".",
    },
    {
      type: "callout",
      tone: "tip",
      title: "Per-report override",
      text: "Call signs change with the shift. Once a call sign is saved in preferences, **Report Settings** in the upload and record modals shows **Call Sign for This Report**, pre-filled with your default. Change it there and it applies to that case only. Your preference is untouched.",
    },
    {
      type: "callout",
      tone: "note",
      text: "The badge number appears in the call sign format only when **Include Badge Number** is on. If the format preview does not show your badge, that is why.",
    },
    {
      type: "paragraph",
      text: "Department admins can push the format and placement so every report in the agency reads the same way, but the call sign itself is always yours. To see how the other fields shape the draft, read Preferences in depth.",
    },
  ],
  related: ["report-preferences-in-depth", "set-up-your-report-preferences"],
};

export default lesson;
